import { GuestWaitingList } from '@seaters/constants';

export const getCurrentSeatCount = (waitingListData: GuestWaitingList) =>
  waitingListData.position?.numberOfSeats ?? 1;

export const getMaxSelectableTickets = (waitingListData: GuestWaitingList) =>
  getCurrentSeatCount(waitingListData);

export const getInitialSelectedTickets = (waitingListData: GuestWaitingList) =>
  getCurrentSeatCount(waitingListData);

export const IXPOLE_FROZEN_ATTENDEE_INFO_MESSAGE =
  'Ixpole attendee info is frozen after ticket registration';

export const getIxpoleGuestSaveErrorTranslationKey = (error: Error) =>
  error.response?.data?.message === IXPOLE_FROZEN_ATTENDEE_INFO_MESSAGE
    ? 'guest_app_ixpole_guests_frozen_error'
    : 'guest_app_ixpole_guests_save_error';
